<ui-card name="Pending Invites">
  <ui-button (buttonClick)="invite.emit()" icon="plus" slot="actions" type="info">Invite Member</ui-button>

  <ui-data-table (request)="onRequest($event)" [columns]="columns" [response]="response"></ui-data-table>
</ui-card>
